// extracted by mini-css-extract-plugin
module.exports = {"container":"WinnerChip_container__lMLK8","chip":"WinnerChip_chip__kWMjx","winner":"WinnerChip_winner__rpq7I"};